import React, {createContext, useContext, useState, useRef, useEffect} from "react";
import {Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {FormattedMessage} from "react-intl";

const ConfirmationDialogContext = createContext({});

export const useConfirmationDialog = () => {
  const context = useContext(ConfirmationDialogContext);
  if (!context) {
    throw new Error('useContactsContext must be used within a ContactsContextProvider');
  }
  return context;
};

const ConfirmationDialogProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [descriptor, setDescriptor] = useState();
  const timerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const openConfirmationDialog = (d) => {
    setDescriptor(d);
  };

  const handleClose = () => {
    if (descriptor?.onClose) {
      descriptor.onClose();
    }
    setDescriptor(null);
    setLoading(false);
  };

  const handleConfirm = () => {
    if (descriptor?.onConfirm) {
      setLoading(true);
      descriptor.onConfirm().then(() => {
        timerRef.current = setTimeout(() => {
          timerRef.current = null;
          handleClose();
        }, 500);
      });
    } else {
      handleClose();
    }
  };

  const handleCancel = () => {
    if (descriptor?.onCancel) {
      descriptor.onCancel().then(() => {
        handleClose();
      });
    } else {
      handleClose();
    }
  };

  return (
    <ConfirmationDialogContext.Provider value={{ openConfirmationDialog }}>
      {children}
      {descriptor && (
        <Dialog
          open={true}
          onClose={handleCancel}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {descriptor.title}
          </DialogTitle>
          <DialogContent>
            <Box mb={2}>
              <DialogContentText id="alert-dialog-description">
                {descriptor.message}
              </DialogContentText>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleCancel}>
              <FormattedMessage id="app.actions.cancel.label" />
            </Button>
            <Button variant="contained" color="error" onClick={handleConfirm} autoFocus loading={loading}>
              {descriptor.confirmLabel || <FormattedMessage id="app.actions.confirm.label"/>}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </ConfirmationDialogContext.Provider>
  );
}

export default ConfirmationDialogProvider;